/* Componente per aggiungere le label per inserire i campi e completare le query */
import React from 'react';
import './Query.css'
import SelectLayer from './SelectLayer'
import SelectField from './SelectField'
import SelectOperator from './SelectOperator'
import SelectValue from './SelectValue'
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';
import {setQuery } from '../redux'
import { useTranslation } from 'react-i18next';
 function AddLayerComponent(props) {
    const [startItem, setStartItem] = React.useState(false);
    const [layer, setLayer] = React.useState('');
    const [field, setField] = React.useState('');
    const [operator, setOperator] = React.useState('');
    const [value, setValue] = React.useState('');
    const [fieldFlag,setFieldFlag] = React.useState(true)
    useTranslation()
  const reset = () =>{

      setStartItem(!startItem)
      setFieldFlag(true)
      props.setQuery({layer:layer,action:false})
  }

  const  handleLayer = (data) =>{
      setLayer(data)
      setFieldFlag(false)
  }

  const  handleField = (data) =>{
    
      setField(data)
  }

  const  handleOperator = (data) =>{
    
      setOperator(data)
  }

  const  handleValue = (data) =>{
      setValue(data)
  }
  //const per far partire la query
const runQuery = () =>{
    var queryValue = value.toLowerCase()
    props.setQuery({layer:layer,field:field,operator:operator,value: queryValue,action:true})
}

const getFields=()=>{
  let data = []
    try {
      const operatorList = window.configFile.serviceOnScreen.operators
      const operator = layer.infoField.fields.find(element=>{return element.fieldLabel === field.fieldLabel}).operator 
        /*operator.map(x=>{
          data.push( operatorList.find(element=> {return element.id === x}))
        })*/
      if(operator){
        operator.map(x=>{
          operatorList.forEach(function(op_element) {
            if(op_element.type === x) data.push(op_element)
          })    
        })           
        return data
      } else return operatorList

    } catch (error) {
        return []
    }
}

  return (
        <div >
            
            <div className={"queryLayer"}>
                <p className={"queryLayerTesto"}>Layer</p>
                <div className={"chooseQueryLayer"}>
                <SelectLayer data ={props.dataList.data} start={startItem} callback={handleLayer.bind(this)}/>
                    
                </div>
                <p className={"queryFieldTesto"}><Trans>Field</Trans></p>
                <div className={"chooseQueryField"}>
                <SelectField data={layer} flag={fieldFlag} start={startItem} callback={handleField.bind(this)}/>
                    
                </div>
                <p className={"queryOperatorTesto"}><Trans>Operator</Trans></p>
                <div className={"chooseQueryOperator"}>
                <SelectOperator  operator={getFields()} start={startItem} callback={handleOperator.bind(this)}/>
                    
                </div>
                <p className={"queryValueTesto"}><Trans>Value</Trans></p>
                <div className={"chooseQueryValue"}>
                <SelectValue  operator={operator} start={startItem} callback={handleValue.bind(this)}/>
                    
                </div>
                <button className={"runQueryStyle"}  onClick={runQuery}><Trans>Run Query</Trans></button>
                <button className={"resetQueryStyle"} onClick={reset} ><Trans>Reset Query</Trans></button>
            </div>
        </div>

  );
}
const mapStateToProps = state => {
  return {
      dataList: state.dataList,
      query: state.query.query

  }
}
  const mapDispatchToProps = dispatch => {
    return {
      setQuery: (query) => dispatch(setQuery(query))
    }
  }
export default connect(mapStateToProps,mapDispatchToProps)(AddLayerComponent)